import {
  LOAD_PATIENT_LIST,
  LOAD_PATIENT_LIST_SUCCESS,
  LOAD_PATIENT_LIST_ERROR,
  //load list for current manage patient
  LOAD_CURRENT_MANAGE_PATIENT_LIST,
  LOAD_CURRENT_MANAGE_PATIENT_LIST_SUCCESS,
  LOAD_CURRENT_MANAGE_PATIENT_LIST_ERROR,
  LOAD_PATIENT_DETAIL,
  LOAD_PATIENT_DETAIL_SUCCESS,
  LOAD_PATIENT_DETAIL_ERROR,
  UPDATE_PATIENT,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_ERROR,
  CREATE_PATIENT,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_ERROR,
  RESET_PATIENT_LIST,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

export const initialState = {
  loadingStatus: {
    patientListLoading: false,
    patientDetailLoading: false,
    createPatientLoading: false,
    updatePatientLoading: false,
  },
  error: '',
  patientList: {
    data: [],
    offset: 0,
    limit: 0,
    total: 0,
  },
  patientDetail: {},
};

const patientReducer = handleActions(
  new Map([
    [
      LOAD_PATIENT_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            patientListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PATIENT_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            patientListLoading: { $set: false },
          },
          patientList: {
            data: { $set: action.payload.data },
            offset: { $set: action.payload.offset },
            limit: { $set: action.payload.limit },
            total: { $set: action.payload.total },
          },
        });
      },
    ],
    [
      LOAD_PATIENT_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            patientListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],

    //load list for current manage patient
    [
      LOAD_CURRENT_MANAGE_PATIENT_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            patientListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_CURRENT_MANAGE_PATIENT_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            patientListLoading: { $set: false },
          },
          patientList: {
            data: { $set: action.payload.data },
            offset: { $set: action.payload.offset },
            limit: { $set: action.payload.limit },
            total: { $set: action.payload.total },
          },
        });
      },
    ],
    [
      LOAD_CURRENT_MANAGE_PATIENT_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            patientListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],

    [
      RESET_PATIENT_LIST,
      (state, action) => {
        return update(state, {
          patientList: {
            data: { $set: [] },
            offset: { $set: 0 },
            limit: { $set: 0 },
            total: { $set: 0 },
          },
        });
      },
    ],

    //Load patient detail
    [
      LOAD_PATIENT_DETAIL,
      state => {
        return update(state, {
          loadingStatus: {
            patientDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PATIENT_DETAIL_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            patientDetailLoading: { $set: true },
          },
          patientDetail: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_PATIENT_DETAIL_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            patientDetailLoading: { $set: true },
          },
        });
      },
    ],

    //Create patient
    [
      CREATE_PATIENT,
      state => {
        return update(state, {
          loadingStatus: {
            createPatientLoading: { $set: true },
          },
        });
      },
    ],
    [
      CREATE_PATIENT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            createPatientLoading: { $set: false },
          },
        });
      },
    ],
    [
      CREATE_PATIENT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            createPatientLoading: { $set: false },
          },
        });
      },
    ],

    //Update patient
    [
      UPDATE_PATIENT,
      state => {
        return update(state, {
          loadingStatus: {
            updatePatientLoading: { $set: true },
          },
        });
      },
    ],
    [
      UPDATE_PATIENT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updatePatientLoading: { $set: false },
          },
          patientDetail: { $set: action.payload },
        });
      },
    ],
    [
      UPDATE_PATIENT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            updatePatientLoading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);
export default patientReducer;
